import type { RadioVariantProps } from "@daangn/carotene";
import React from "react";

export const RadioAnchorContext = React.createContext<{
  size: RadioVariantProps["size"];
  defaultValue: string | undefined;
} | null>(null);

export const useRadioAnchorContext = () => {
  const context = React.useContext(RadioAnchorContext);
  if (!context) {
    throw new Error(
      `RadioAnchor cannot be rendered outside the RadioAnchorGroup`,
    );
  }
  return context;
};
